import {match, Pattern} from 'ts-pattern';

import {
  FINANCING_ENDING_BULK_OPERATION_ITEM_STATE,
  FINANCING_ENDING_EMAIL_OUTCOME,
  type FinancingEndingBulkOperationItemResponseBody,
} from '@dms/api/sales';

import {FINANCING_ENDING_OPERATION_ITEM_RESULT} from '../constants/FINANCING_ENDING_OPERATION_ITEM_RESULT';

/**
 * A skipped or failed row wins over its e-mail outcome. A done row without a known e-mail outcome
 * (an older backend, or an outcome added on the server) has no result.
 */
export const getFinancingEndingOperationItemResult = (
  item: Pick<FinancingEndingBulkOperationItemResponseBody, 'state' | 'emailOutcome'>
) =>
  match(item)
    .with(
      {state: FINANCING_ENDING_BULK_OPERATION_ITEM_STATE.SKIPPED},
      () => FINANCING_ENDING_OPERATION_ITEM_RESULT.SKIPPED
    )
    .with(
      {state: FINANCING_ENDING_BULK_OPERATION_ITEM_STATE.FAILED},
      () => FINANCING_ENDING_OPERATION_ITEM_RESULT.FAILED
    )
    .with(
      {emailOutcome: FINANCING_ENDING_EMAIL_OUTCOME.SENT},
      () => FINANCING_ENDING_OPERATION_ITEM_RESULT.SENT
    )
    .with(
      {emailOutcome: FINANCING_ENDING_EMAIL_OUTCOME.FAILED},
      () => FINANCING_ENDING_OPERATION_ITEM_RESULT.NOT_DELIVERED
    )
    .with(
      {emailOutcome: FINANCING_ENDING_EMAIL_OUTCOME.BLOCKED},
      () => FINANCING_ENDING_OPERATION_ITEM_RESULT.BLOCKED
    )
    .with(
      {
        emailOutcome: Pattern.union(
          FINANCING_ENDING_EMAIL_OUTCOME.CREATED,
          FINANCING_ENDING_EMAIL_OUTCOME.PENDING
        ),
      },
      () => FINANCING_ENDING_OPERATION_ITEM_RESULT.PENDING
    )
    .with(
      {
        state: Pattern.union(
          FINANCING_ENDING_BULK_OPERATION_ITEM_STATE.PENDING,
          FINANCING_ENDING_BULK_OPERATION_ITEM_STATE.IN_PROGRESS
        ),
      },
      () => FINANCING_ENDING_OPERATION_ITEM_RESULT.PENDING
    )
    .otherwise(() => null);
